(() => {

  const root = document;
  const form = document.querySelector("#tattoo-form, form.tattoo-form");
  const fileInput = root.querySelector("#reference-photos-template--30129160618358blocksbthdhe");
  const uploadZone = root.querySelector("#upload-zone-template--30129160618358blocksbthdhe");
  const uploadCount = root.querySelector("#upload-count-template--30129160618358blocksbthdhe");
  const previewGrid = root.querySelector("#preview-grid-template--30129160618358blocksbthdhe");
  const referenceError = root.querySelector("#reference-error-template--30129160618358blocksbthdhe");
  const formMessage = root.querySelector("#form-message-template--30129160618358blocksbthdhe");
  const submitButton = root.querySelector("#submit-template--30129160618358blocksbthdhe");
  const confirmationSelect = root.querySelector("#confirm-order-template--30129160618358blocksbthdhe");
  const confirmationError = root.querySelector('[data-error-for="confirm_order"]');

  if (!form) {
    console.error("[Leyl booking] Booking form not found.");
    return;
  }

  if (!fileInput || !uploadZone || !uploadCount || !previewGrid || !referenceError || !formMessage || !submitButton || !confirmationSelect || !confirmationError) {
    console.error("[Leyl booking] Booking UI is incomplete.");
    return;
  }

  console.info("[Leyl booking] Backend handler active.");

  const FLOW_KEY = "leyl_booking_flow_v1";
  const newRequestId = () => crypto.randomUUID();
  let requestId = newRequestId();
  let requestFingerprint = null;
  const DB_NAME = "leyl_booking_files_v1";
  const previewId = new URLSearchParams(location.search).get("preview_theme_id");
  function flowUrl(path) { return path + (previewId ? "?preview_theme_id=" + encodeURIComponent(previewId) : ""); }
  function fileStore(mode, operation) {
    return new Promise((resolve, reject) => {
      const opening = indexedDB.open(DB_NAME, 1);
      opening.onupgradeneeded = () => opening.result.createObjectStore("pending");
      opening.onerror = () => reject(opening.error);
      opening.onsuccess = () => {
        const db = opening.result;
        const tx = db.transaction("pending", mode);
        const request = operation(tx.objectStore("pending"));
        let output;
        request.onsuccess = () => { output = request.result; };
        tx.oncomplete = () => { db.close(); resolve(output); };
        tx.onerror = () => { db.close(); reject(tx.error); };
      };
    });
  }
  const saveFiles = files => fileStore("readwrite", store => store.put(files, "photos"));
  const loadFiles = () => fileStore("readonly", store => store.get("photos"));
  const deleteFiles = () => fileStore("readwrite", store => store.delete("photos"));
  function captureFields() {
    return Array.from(form.elements).filter(el => el.name && el.type !== "file").map(el =>
      ({name:el.name, value:el.value, checked:el.matches('[type="checkbox"],[type="radio"]') ? el.checked : null})
    );
  }
  function restoreFields(fields) {
    for(const field of fields) {
      const el = Array.from(form.elements).find(el =>
        el.name === field.name && el.type !== "file" &&
        (field.checked === null || el.value === field.value));
      if (!el) continue;
      if (field.checked === null) el.value = field.value;
      else el.checked = field.checked;
      el.dispatchEvent(new Event("change",{bubbles:true}));
    }
  }
  function getFlow() {
    try {
      const flow = JSON.parse(sessionStorage.getItem(FLOW_KEY) || "null");
      if (flow && Date.now() - flow.created < (flow.phase === "retry" ? 86400000 : 240000)) return flow;
    } catch(e) {}
    sessionStorage.removeItem(FLOW_KEY);
    return null;
  }
  async function goToSecurityCheck() {
    await saveFiles(selectedFiles);
    sessionStorage.setItem(FLOW_KEY, JSON.stringify({created:Date.now(),phase:"challenge",fields:captureFields(),theme:previewId,requestId,fingerprint:requestFingerprint}));
    location.assign(flowUrl("/pages/security-hcaptcha-preview"));
  }

  let turnstileScript;
  async function verifyAutomatically() {
    if (!window.turnstile) {
      if (!turnstileScript) turnstileScript = new Promise((resolve,reject)=>{
        const tag=document.createElement("script");
        tag.src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        tag.onload=()=>window.turnstile?resolve():reject(new Error("Security check unavailable."));
        tag.onerror=()=>reject(new Error("Security check unavailable."));
        document.head.appendChild(tag);
      });
      await turnstileScript;
    }
    return new Promise((resolve,reject)=>{
      const mount=document.createElement("div");
      mount.style.cssText="position:absolute;left:-10000px;top:0;width:300px;height:75px;pointer-events:none";
      document.body.appendChild(mount);
      let done=false,id,timer;
      function finish(error,token){
        if(done)return;
        done=true;clearTimeout(timer);
        try{if(id!==undefined)window.turnstile.remove(id)}catch(e){}
        mount.remove();
        if(error)reject(error);else resolve(token);
      }
      try{
        id=window.turnstile.render(mount,{
          sitekey:"0x4AAAAAAFVlVVP2KoIQWj1z",action:"booking",
          theme:"dark",appearance:"interaction-only",execution:"execute",
          "before-interactive-callback":()=>goToSecurityCheck().then(()=>finish(null,null)).catch(e=>finish(e)),
          callback:token=>finish(null,token),
          "error-callback":()=>finish(new Error("Security verification failed. Please try again.")),
          "timeout-callback":()=>finish(new Error("Security verification timed out.")),
          "expired-callback":()=>finish(new Error("Security verification expired."))
        });
        timer=setTimeout(()=>finish(new Error("Security verification timed out.")),30000);
        window.turnstile.execute(id);
      }catch(e){finish(new Error("Security verification unavailable."))}
    });
  }

  const API_BASE = "https://leyl-booking-backend.john-karlsson-ns.workers.dev";
  const MAX_FILES = 6;
  const MAX_BYTES = 10 * 1024 * 1024;
  const ALLOWED_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);

  let selectedFiles = [];
  let previewUrls = [];

  const showMessage = (message, isError = false) => {
    formMessage.textContent = message;
    formMessage.classList.add("is-visible");
    formMessage.classList.toggle("is-error", isError);
    formMessage.setAttribute("role", isError ? "alert" : "status");
    formMessage.setAttribute("tabindex", "-1");
    formMessage.style.outline = "none";
    formMessage.style.boxShadow = "none";
    // The submit button is above the receipt. Move the view to the
    // actual result after the asynchronous upload and email steps.
    window.requestAnimationFrame(() => {
      formMessage.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      formMessage.focus({ preventScroll: true });
    });
  };

  const clearSuccessfulBooking = async () => {
    sessionStorage.removeItem(FLOW_KEY);
    requestId = newRequestId();
    requestFingerprint = null;
    form.reset();
    // Explicitly clear values: reset() alone can restore browser/autofill defaults.
    for (const el of Array.from(form.elements)) {
      if (el.type === "file") { try { el.value = ""; } catch (_) {} }
      else if (el.matches('input[type="checkbox"],input[type="radio"]')) el.checked = false;
      else if (el.matches('input[type="text"],input[type="email"],input[type="tel"],input[type="number"],textarea')) el.value = "";
      else if (el.tagName === "SELECT") {
        const initial = Array.from(el.options).find(opt => opt.defaultSelected);
        if (initial) el.value = initial.value;
        else if (Array.from(el.options).some(opt => opt.value === "")) el.value = "";
        else el.selectedIndex = 0;
      }
    }
    // Update dynamic conditional fields after select changes.
    form.querySelectorAll("select").forEach(el => el.dispatchEvent(new Event("change", { bubbles:true })));
    selectedFiles = [];
    renderFiles();
    await deleteFiles().catch(console.error);
  };

  const clearMessage = () => {
    formMessage.textContent = "";
    formMessage.classList.remove("is-visible", "is-error");
  };

  const showReferenceError = (message = "") => {
    referenceError.textContent = message;
    referenceError.classList.toggle("is-visible", Boolean(message));
  };

  const showConfirmationError = (message = "") => {
    confirmationError.textContent = message;
    confirmationError.classList.toggle("is-visible", Boolean(message));
    confirmationSelect.setAttribute("aria-invalid", message ? "true" : "false");
  };

  confirmationSelect.addEventListener("change", () => {
    if (confirmationSelect.value === "confirm") {
      showConfirmationError("");
    } else if (confirmationSelect.value === "decline") {
      showConfirmationError("Please confirm the booking to continue.");
    } else {
      showConfirmationError("");
    }
  });

  const clearPreviews = () => {
    previewUrls.forEach((url) => URL.revokeObjectURL(url));
    previewUrls = [];
    previewGrid.innerHTML = "";
  };

  const renderFiles = () => {
    clearPreviews();

    uploadCount.textContent =
      selectedFiles.length === 0
        ? "No images selected"
        : `${selectedFiles.length} of ${MAX_FILES} image${selectedFiles.length === 1 ? "" : "s"} selected`;

    selectedFiles.forEach((file, index) => {
      const url = URL.createObjectURL(file);
      previewUrls.push(url);

      const item = document.createElement("div");
      item.className = "preview-item";

      const image = document.createElement("img");
      image.src = url;
      image.alt = `Reference preview ${index + 1}`;

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "preview-remove";
      remove.setAttribute("aria-label", `Remove ${file.name}`);
      remove.textContent = "×";
      remove.addEventListener("click", () => {
        selectedFiles.splice(index, 1);
        showReferenceError("");
        renderFiles();
      });

      const name = document.createElement("div");
      name.className = "preview-name";
      name.textContent = file.name;

      item.append(image, remove, name);
      previewGrid.appendChild(item);
    });
  };

  const addFiles = (files) => {
    showReferenceError("");

    for (const file of files) {
      if (selectedFiles.length >= MAX_FILES) {
        showReferenceError(`Maximum ${MAX_FILES} images allowed.`);
        break;
      }

      if (!ALLOWED_TYPES.has(file.type)) {
        showReferenceError("Only JPG, JPEG, PNG and WEBP images are allowed.");
        continue;
      }

      if (file.size > MAX_BYTES) {
        showReferenceError(`${file.name} exceeds the 10 MB limit.`);
        continue;
      }

      const duplicate = selectedFiles.some(
        (existing) =>
          existing.name === file.name &&
          existing.size === file.size &&
          existing.lastModified === file.lastModified
      );

      if (!duplicate) selectedFiles.push(file);
    }

    renderFiles();
  };

  fileInput.addEventListener("change", () => {
    addFiles(Array.from(fileInput.files || []));
    fileInput.value = "";
  });

  uploadZone.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      fileInput.click();
    }
  });

  ["dragenter", "dragover"].forEach((type) => {
    uploadZone.addEventListener(type, (event) => {
      event.preventDefault();
      uploadZone.classList.add("is-dragging");
    });
  });

  ["dragleave", "drop"].forEach((type) => {
    uploadZone.addEventListener(type, (event) => {
      event.preventDefault();
      uploadZone.classList.remove("is-dragging");
    });
  });

  uploadZone.addEventListener("drop", (event) => {
    addFiles(Array.from(event.dataTransfer?.files || []));
  });

  const readJson = async (response) => {
    const text = await response.text();
    if (!text) return {};
    try {
      return JSON.parse(text);
    } catch (_) {
      return { error: text };
    }
  };

  const requireOk = async (response, fallback) => {
    const body = await readJson(response);
    if (!response.ok) {
      throw new Error(body.error || fallback);
    }
    return body;
  };

  let submitting = false;

  // Disable Shopify's native contact-form fallback once this script is loaded.
  form.onsubmit = () => false;
  form.setAttribute("action", "#tattoo-form");

  const handleBookingSubmit = async (event, approvedToken = null) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (submitting) return;

    clearMessage();
    showReferenceError("");
    showConfirmationError("");

    if (confirmationSelect.value !== "confirm") {
      showConfirmationError(
        confirmationSelect.value === "decline"
          ? "Please confirm the booking to continue."
          : "Please choose Confirm Order to continue."
      );
      confirmationSelect.focus();
      confirmationSelect.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      return;
    }

    if (!form.reportValidity()) return;

    // Keep the same ID only for exactly the same submitted form.
    // Editing a previous/failed booking must create a new attempt.
    const currentFingerprint = JSON.stringify(captureFields());
    if (requestFingerprint !== null && currentFingerprint !== requestFingerprint) {
      requestId = newRequestId();
    }
    requestFingerprint = currentFingerprint;

    // Lock synchronously: two rapid clicks must not start parallel bookings.
    submitting = true;
    submitButton.disabled = true;
    const originalButtonText = submitButton.textContent;
    submitButton.textContent = "Submitting...";

    try {
      // Save draft while submission is locked, including selected photos.
      if (!approvedToken) {
        try {
          await saveFiles(selectedFiles);
          sessionStorage.setItem(FLOW_KEY, JSON.stringify({
            created:Date.now(),phase:"draft",fields:captureFields(),theme:previewId,requestId
          }));
        } catch(e) { console.warn("Could not save booking draft",e); }
      }
      const turnstileToken = approvedToken || await verifyAutomatically();
      if (!turnstileToken) return;
      const startResponse = await fetch(`${API_BASE}/api/bookings/start`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          turnstileToken,
          requestId,
          firstName: root.querySelector("#first-name-template--30129160618358blocksbthdhe").value,
          lastName: root.querySelector("#last-name-template--30129160618358blocksbthdhe").value,
          email: root.querySelector("#email-template--30129160618358blocksbthdhe").value,
          countryCode: root.querySelector("#country-code-template--30129160618358blocksbthdhe").value === "Other" ? root.querySelector("#other-country-code-template--30129160618358blocksbthdhe").value : root.querySelector("#country-code-template--30129160618358blocksbthdhe").value,
          phone: root.querySelector("#phone-template--30129160618358blocksbthdhe").value,
          placement: root.querySelector("#placement-template--30129160618358blocksbthdhe").value,
          style: root.querySelector("#style-template--30129160618358blocksbthdhe").value,
          placementOther: root.querySelector("#placement-detail-template--30129160618358blocksbthdhe").value,
          styleOther: root.querySelector("#style-detail-template--30129160618358blocksbthdhe").value,
          themes: root.querySelector("#themes-template--30129160618358blocksbthdhe").value,
          themesOther: root.querySelector("#themes-detail-template--30129160618358blocksbthdhe").value,
          timing: root.querySelector("#timing-template--30129160618358blocksbthdhe").value,
          timingOther: root.querySelector("#timing-detail-template--30129160618358blocksbthdhe").value,
          suitableDays: Array.from(form.querySelectorAll(".booking-day-grid input[type=checkbox]:checked")).map(node => node.value),
          message: root.querySelector("#message-template--30129160618358blocksbthdhe").value,
          confirmation: root.querySelector("#confirm-order-template--30129160618358blocksbthdhe").value
        })
      });

      const booking = await requireOk(startResponse, "Could not start booking.");
      if (booking.alreadyComplete) {
        showMessage(`Thank you. Your booking request ${booking.bookingId} has already been received. Please do not submit it again.`);
        await clearSuccessfulBooking();
        return;
      }

      for (let index = 0; index < selectedFiles.length; index += 1) {
        const file = selectedFiles[index];
        submitButton.textContent = `Uploading ${index + 1}/${selectedFiles.length}...`;

        const safeFilename = file.name.replace(/[^\x20-\x7E]/g, "_");

        const uploadResponse = await fetch(booking.uploadUrl, {
          method: "POST",
          headers: {
            "Content-Type": file.type,
            "X-Filename": safeFilename,
            "X-Booking-Token": booking.uploadToken
          },
          body: file
        });

        await requireOk(uploadResponse, `Could not upload ${file.name}.`);
      }

      submitButton.textContent = "Finishing...";

      const completeResponse = await fetch(booking.completeUrl, {
        method: "POST",
        headers: {"X-Booking-Token":booking.uploadToken}
      });

      await requireOk(completeResponse, "Could not complete booking.");

      showMessage(`Thank you. Your booking request ${booking.bookingId} has been received. I will review the request and reply before any appointment is confirmed.`);

      await clearSuccessfulBooking();


    } catch (error) {
      console.error(error);
      showMessage(
        error instanceof Error
          ? error.message
          : "Something went wrong. Please try again.",
        true
      );
    } finally {
      submitting = false;
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  };

  form.addEventListener("submit", handleBookingSubmit, true);
  submitButton.addEventListener("click", (event) => {
    event.preventDefault();
    handleBookingSubmit(event);
  });

  renderFiles();
  (async () => {
    const pending = getFlow();
    if (!pending) return;
    try {
      requestId = pending.requestId || requestId;
      requestFingerprint = pending.fingerprint || JSON.stringify(pending.fields);
      restoreFields(pending.fields);
      const files = await loadFiles();
      if (Array.isArray(files)) { selectedFiles = files; renderFiles(); }
      if (pending.phase !== "verified" || !pending.token) return;
      sessionStorage.setItem(FLOW_KEY, JSON.stringify({...pending,phase:"submitting",token:null}));
      await handleBookingSubmit(null, pending.token);
    } catch(err) {
      console.error(err);
      showMessage("Your booking could not be restored. Please try again.", true);
      sessionStorage.removeItem(FLOW_KEY);
    }
  })();
})();